export default "__VITE_ASSET__e8039925__"